import { AppLogsTable } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { useOpportunityActionLogs } from '@opportunities/$opportunityId/-hooks/useOpportunityActionLogs'
import { useMemo } from 'react'
import { createLogColumns } from './components/columns'

interface LogsTabProps {
  opportunityId: number
}
export function LogsTab({ opportunityId }: LogsTabProps) {
  const { data, isLoading, error } = useOpportunityActionLogs(opportunityId, {
    limit: 100,
  })

  const columns = useMemo(() => createLogColumns(), [])
  const logs = data?.logs ?? []

  return (
    <AppLogsTable
      data={logs}
      columns={columns}
      isLoading={isLoading}
      errorMessage={error ? `操作ログの取得に失敗しました: ${error.message}` : undefined}
      pageSize={100}
      emptyMessage='操作ログはまだありません'
    />
  )
}
